var map = {
	"./kenya/1-full-sm.jpg": "ccc3",
	"./kenya/10-half-sm.jpg": "2327",
	"./kenya/11-half-sm.jpg": "35d4",
	"./kenya/12-full-sm.jpg": "bf20",
	"./kenya/13-half-sm.jpg": "10f0",
	"./kenya/14-half-sm.jpg": "1ed5",
	"./kenya/15-half-sm.jpg": "491a",
	"./kenya/2-half-sm.jpg": "93f6",
	"./kenya/3-full-sm.jpg": "571f",
	"./kenya/4-half-sm.jpg": "9945",
	"./kenya/5-half-sm.jpg": "5224",
	"./kenya/6-half-sm.jpg": "3086",
	"./kenya/7-full-sm.jpg": "7ef2",
	"./kenya/8-full-sm.jpg": "9aa1",
	"./kenya/9-full-sm.jpg": "4522",
	"./kenya/home-sm.jpg": "d8c2",
	"./kenya/main-sm.jpg": "cc5c",
	"./nepal/1-half-sm.jpg": "4bc5",
	"./nepal/10-half-sm.jpg": "7f45",
	"./nepal/11-half-sm.jpg": "a372",
	"./nepal/12-half-sm.jpg": "c281",
	"./nepal/13-full-sm.jpg": "1b98",
	"./nepal/14-full-sm.jpg": "69ad",
	"./nepal/15-half-sm.jpg": "f876",
	"./nepal/16-full-sm.jpg": "2f17",
	"./nepal/17-half-sm.jpg": "42be",
	"./nepal/18-full-sm.jpg": "f565",
	"./nepal/19-half-sm.jpg": "8b24",
	"./nepal/2-full-sm.jpg": "1156",
	"./nepal/3-half-sm.jpg": "e225",
	"./nepal/4-full-sm.jpg": "e93b",
	"./nepal/5-half-sm.jpg": "501e",
	"./nepal/6-full-sm.jpg": "08e9",
	"./nepal/7-full-sm.jpg": "bb79",
	"./nepal/8-full-sm.jpg": "e86a",
	"./nepal/9-half-sm.jpg": "6494",
	"./nepal/home-sm.jpg": "5141",
	"./nepal/main-sm.jpg": "1e80",
	"./norway/1-full-sm.jpg": "2ba7",
	"./norway/10-half-sm.jpg": "4ea5",
	"./norway/11-half-sm.jpg": "95c5",
	"./norway/12-half-sm.jpg": "3f43",
	"./norway/13-half-sm.jpg": "bbb6",
	"./norway/14-full-sm.jpg": "defb",
	"./norway/15-half-sm.jpg": "90cd",
	"./norway/16-half-sm.jpg": "b648",
	"./norway/17-full-sm.jpg": "1737",
	"./norway/18-half-sm.jpg": "f45d",
	"./norway/19-full-sm.jpg": "a1fe",
	"./norway/2-full-sm.jpg": "8136",
	"./norway/3-half-sm.jpg": "497d",
	"./norway/4-half-sm.jpg": "50dc",
	"./norway/5-full-sm.jpg": "e55a",
	"./norway/6-half-sm.jpg": "6f26",
	"./norway/7-half-sm.jpg": "ada1",
	"./norway/8-full-sm.jpg": "3d6b",
	"./norway/9-full-sm.jpg": "516b",
	"./norway/home-sm.jpg": "1de1",
	"./norway/main-sm.jpg": "f7a9",
	"./pakistan/1-full-sm.jpg": "b522",
	"./pakistan/2-full-sm.jpg": "6c6b",
	"./pakistan/3-half-sm.jpg": "8e64",
	"./pakistan/4-full-sm.jpg": "9617",
	"./pakistan/5-half-sm.jpg": "2603",
	"./pakistan/6-half-sm.jpg": "5c9e",
	"./pakistan/7-half-sm.jpg": "c524",
	"./pakistan/8-half-sm.jpg": "6ab8",
	"./pakistan/home-sm.jpg": "30ab",
	"./pakistan/jamia-half-sm.jpg": "d870",
	"./pakistan/main-sm.jpg": "8f21",
	"./pakistan/mufti-half-sm.jpg": "d16e",
	"./pakistan/muna-full-sm.jpg": "c269",
	"./pakistan/students-full-sm.jpg": "3b30",
	"./placeholder/home-sm.jpg": "fcb6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d96c";